module.exports = __webpack_public_path__ + "img/paste.d987db6c.svg";